import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import AuthLayout from './AuthLayout';
import { setToken } from '../api/http';
import { setUser } from '../store';

export default function Logout() {
    const history = useHistory();
    const dispatch = useDispatch();

    useEffect(() => {
        setToken(null);
        dispatch(setUser(null));
        window.dispatchEvent(new Event('tacho-auth'));
        const t = setTimeout(() => history.replace('/login'), 1000);
        return () => clearTimeout(t);
    }, []);

    return (
        <AuthLayout>
            <div className="auth-text">Odjavljivanje uspešno</div>
        </AuthLayout>
    );
}
